import React, { useEffect, useState } from 'react';

import { createResourceLocatorString } from '../../util/routes';

import css from './SearchPage.module.css';

const OFFER_SEARCH_PHRASE = /\b(?:accepting offers|offers welcome)\b/gi;

export const parseOfferSearch = value => {
  const searchText = value.trim();
  const activatesOfferFilter = OFFER_SEARCH_PHRASE.test(searchText) || /^offers$/i.test(searchText);
  OFFER_SEARCH_PHRASE.lastIndex = 0;
  return {
    keywords: /^offers$/i.test(searchText)
      ? ''
      : searchText.replace(OFFER_SEARCH_PHRASE, ' ').replace(/\s+/g, ' ').trim(),
    activatesOfferFilter,
  };
};

const MarketplaceBrowseControls = props => {
  const {
    history,
    routeConfiguration,
    validQueryParams,
    onToggleFilters,
    selectedFiltersCount = 0,
    showSearchControls = true,
  } = props;
  const [keywords, setKeywords] = useState(validQueryParams.keywords || '');

  useEffect(() => {
    setKeywords(validQueryParams.keywords || '');
  }, [validQueryParams.keywords]);

  const onSubmit = event => {
    event.preventDefault();
    const { keywords: previousKeywords, ...existingFilters } = validQueryParams;
    const { keywords: parsedKeywords, activatesOfferFilter } = parseOfferSearch(keywords);
    const nextSearch = {
      ...existingFilters,
      ...(parsedKeywords ? { keywords: parsedKeywords } : {}),
      ...(activatesOfferFilter ? { pub_acceptOffers: 'yes' } : {}),
    };
    history.push(createResourceLocatorString('SearchPage', routeConfiguration, {}, nextSearch));
  };

  return (
    <section className={css.marketplaceBrowse} aria-label="Marketplace search controls">
      {showSearchControls ? (
        <form className={css.marketplaceSearchForm} onSubmit={onSubmit}>
          <label htmlFor="marketplace-keywords">Search marketplace</label>
          <div className={css.marketplaceSearchRow}>
            <input
              id="marketplace-keywords"
              type="search"
              value={keywords}
              onChange={event => setKeywords(event.target.value)}
              placeholder="Search titles or authors"
            />
            <button type="submit" className={css.marketplaceSearchButton}>
              Search
            </button>
            {onToggleFilters ? (
              <button
                type="button"
                className={css.marketplaceFiltersButton}
                onClick={onToggleFilters}
                aria-label="Open filters"
              >
                Filters{selectedFiltersCount ? ` (${selectedFiltersCount})` : ''}
              </button>
            ) : null}
          </div>
        </form>
      ) : null}

    </section>
  );
};

export default MarketplaceBrowseControls;
